import { render, staticRenderFns } from "./our-safety-tools.vue?vue&type=template&id=037c2034&scoped=true"
import script from "./our-safety-tools.vue?vue&type=script&lang=js"
export * from "./our-safety-tools.vue?vue&type=script&lang=js"
import style0 from "./our-safety-tools.vue?vue&type=style&index=0&id=037c2034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037c2034",
  null
  
)

export default component.exports